export class MongoAtlasRequiredPrivateLink {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "provider",
            "baseName": "provider",
            "type": "MongoAtlasPrivateLinkProvider",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterNames",
            "baseName": "clusterNames",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasRequiredPrivateLink.attributeTypeMap;
    }
    constructor() {
    }
}
